import { Auth } from 'aws-amplify'
// import HelperService from 'App/Services/HelperService'

/**
 * @file Contain all constants that are used 
 * throught the project
 **/

/**
 * @summary kiss bind error codes
 */
export const Colors = {
  transparent: 'rgba(0,0,0,0)',
  white: '#FFFFFF',
  black: '#000000',

  dark: '#152383',
  medium: '#17267E',
  light: '#F0F0F0',
  highlight: '#35C2CF',
  lightGrey: '#898989',
  lightGrey20: '#89898933',
  darkGrey: '#444444',
  darkGrey30: '#4444444C',
  vlightGrey: '#B8B8B8',


  hint: '#A0A0A0',
  link: '#0000FF',
  error: '#AA0004',
  positive: '#178722',

  primary: '#263CAB',
  secondary: '#5472EA',
  secondary20: '#5472EA33',
  lightBlue: '#8C9BE8',
  mediumBlue: '#21529B'
  
}
export const Images = {
  // tool: require('../Assets/Images/device.webp'),
  // packaging: require('../Assets/Images/packaging.webp'),
  // splashDevice: require('../Assets/Images/splashDevice.webp'),
  // next: require('../Assets/Images/next.webp'),
  addTool: require('../Assets/Images/AddTool.webp'),
  toolButton: require('../Assets/Images/ToolButton.webp'),
  toolError: require('../Assets/Images/ToolError.webp'),
  toolNFC: require('../Assets/Images/ToolNFC.gif'),//MISSING webp
  toolScan: require('../Assets/Images/ToolScan.webp'),
  toolWifi: require('../Assets/Images/ToolWifi.webp'),
  tools: require('../Assets/Images/Tools.png'),//MISSING webp
  noTools: require('../Assets/Images/NoTools.webp'),
  noAlerts: require('../Assets/Images/NoAlerts.webp'),
  noMessages: require('../Assets/Images/NoMessages.webp'),
  noSessions: require('../Assets/Images/NoSessions.webp'),
  toolAccount:require('../Assets/Images/ToolAccount.webp'),
  toolIot:require('../Assets/Images/ToolIot.webp'),
  wifiScan:require('../Assets/Images/WifiScan.webp'),
  toolPhone:require('../Assets/Images/ToolPhone.webp'),
  phoneToolWifi:require('../Assets/Images/PhoneToolWifi.webp'),
  toolFirmware:require('../Assets/Images/ToolFirmware.webp'),
  toolAdded:require('../Assets/Images/ToolAdded.webp'),
  changeWifi:require('../Assets/Images/ChangeWiFi.webp'),
  stratusLoading:require('../Assets/Images/StratusLoadingBlue.gif'),
  beaker1:require('../Assets/Images/Beaker2.png'),
  beaker2:require('../Assets/Images/Beaker3.png'),
  beaker3:require('../Assets/Images/Beaker1.png'),
  calibration1:require('../Assets/Images/CalibrationSetup2.png'),
  calibration2:require('../Assets/Images/CalibrationSetup3.png'),
  calibration3:require('../Assets/Images/CalibrationSetup1.png'),
  welcomeTutorial:require('../Assets/Images/WelcomeTutorial.png'),
  dashboardTutorial:require('../Assets/Images/DashboardTutorial.png'),
  toolOverviewTutorial:require('../Assets/Images/ToolOverviewTutorial.png'),
  exportTutorial:require('../Assets/Images/ExportTutorial.png'),
  sessionsTutorial:require('../Assets/Images/SessionsTutorial.png'),
  shareTutorial:require('../Assets/Images/ShareTutorial.png'),
  loggingTutorial:require('../Assets/Images/LoggingTutorial.png'),
  supportTutorial:require('../Assets/Images/SupportTutorial.png'),
  thpTutorial1:require('../Assets/Images/ThpTutorial1.png'),
  thpTutorial2:require('../Assets/Images/ThpTutorial2.png'),
  toolTutorialLogging:require('../Assets/Images/ToolTutorialLogging.png'),
  t4cTutorial1:require('../Assets/Images/T4CTutorial1.png'),
  t4cTutorial2:require('../Assets/Images/T4CTutorial2.png'),
  a4cTutorial1:require('../Assets/Images/A4CTutorial1.png'),
  a4cTutorial2:require('../Assets/Images/A4CTutorial2.png'),
  a4cTutorial3:require('../Assets/Images/A4CTutorial3.png'),
  a4cTutorial4:require('../Assets/Images/A4CTutorial4.png'),
  cp1Tutorial1:require('../Assets/Images/CP1Tutorial1.png'),
  visa:require('../Assets/Images/Visa.png'),
  amex:require('../Assets/Images/Amex.png'),
  discover:require('../Assets/Images/Discover.png'),
  mastercard:require('../Assets/Images/Mastercard.png'),
  cards:require('../Assets/Images/Cards.png'),
  amexCVV:require('../Assets/Images/amexCVV.png'),
  cardCVV:require('../Assets/Images/cardCVV.png'),
}

export const Spacing = { none: 0, xm: 4, sm: 8, md: 16, lg: 24, xl: 32, xxl:48, xxxl:60,compWidth:60 }
export const Helpers = {
  backgroundReset: {
    backgroundColor: Colors.transparent,
  },
  center: {
    display:'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  colCenter: {
    display:'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  colCross: {
    display:'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  colMain: {
    display:'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  column: {
    display:'flex',
    flexDirection: 'column',
  },
  columnReverse: {
    display:'flex',
    flexDirection: 'column-reverse',
  },
  crossCenter: {
    display:'flex',
    alignItems: 'center',
  },
  crossEnd: {
    display:'flex',
    alignItems: 'flex-end',
  },
  crossStart: {
    display:'flex',
    alignItems: 'flex-start',
  },
  crossStretch: {
    display:'flex',
    alignItems: 'stretch',
  },
  fill: {
    display:'flex',
    flexDirection:'row',
    flex: 1,
  },
  fillCenter: {
    display:'flex',
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  fillCol: {
    display:'flex',
    flex: 1,
    flexDirection: 'column',
  },
  fillColCenter: {
    display:'flex',
    alignItems: 'center',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  fillColCross: {
    display:'flex',
    alignItems: 'center',
    flex: 1,
    flexDirection: 'column',
  },
  fillColMain: {
    display:'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  fillColReverse: {
    display:'flex',
    flex: 1,
    flexDirection: 'column-reverse',
  },
  fillRow: {
    display:'flex',
    flex: 1,
    flexDirection: 'row',
  },
  fillRowCenter: {
    display:'flex',
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  fillRowCross: {
    display:'flex',
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
  },
  fillRowMain: {
    display:'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  fillRowReverse: {
    display:'flex',
    flex: 1,
    flexDirection: 'row-reverse',
  },
  fullSize: {
    height: '100%',
    width: '100%',
  },
  fullWidth: {
    width: '100%',
  },
  square: {
    aspectRatio: 1,
  },
  mainCenter: {
    justifyContent: 'center',
  },
  mainEnd: {
    justifyContent: 'flex-end',
  },
  mainSpaceAround: {
    justifyContent: 'space-around',
  },
  mainSpaceBetween: {
    justifyContent: 'space-between',
  },
  mainStart: {
    justifyContent: 'flex-start',
  },
  mirror: {
    transform: [{ scaleX: -1 }],
  },
  rotate90: {
    transform: [{ rotate: '90deg' }],
  },
  rotate90Inverse: {
    transform: [{ rotate: '-90deg' }],
  },
  row: {
    display:'flex',
    flexDirection: 'row',
  },
  rowCenter: {
    display:'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  rowCross: {
    display:'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  rowMain: {
    display:'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  rowReverse: {
    display:'flex',
    flexDirection: 'row-reverse',
  },
  scrollSpaceAround: {
    flexGrow: 1,
    justifyContent: 'space-around',
  },
  scrollSpaceBetween: {
    flexGrow: 1,
    justifyContent: 'space-between',
  },
  selfStretch: {
    alignSelf: 'stretch',
  },
  textCenter: {
    textAlign: 'center',
  },
  textJustify: {
    textAlign: 'justify',
  },
  textLeft: {
    textAlign: 'left',
  },
  textRight: {
    textAlign: 'right',
  },
}
// export const size = {
//   h1: Math.floor(Math.min(width,height) / 9), //38 on 360 width screen
//   h2: Math.floor(Math.min(width,height) / 10), //34 on 360 width screen
//   h3: Math.floor(Math.min(width,height) / 12), //30 on 360 width screen
//   input: Math.floor(Math.min(width,height) / 20), //18 on 360 width screen
//   xxxlarge: Math.floor(Math.min(width,height) / 9), //40 on 360 width screen
//   xxlarge: Math.floor(Math.min(width,height) / 14), //25 on 360 width screen
//   xlarge: Math.floor(Math.min(width,height) / 18), //20 on 360 width screen
//   large: Math.floor(Math.min(width,height) / 21), //17 on 360 width screen
//   regular: Math.floor(Math.min(width,height) / 22), //16 on 360 width screen
//   medium: Math.floor(Math.min(width,height) / 22), //16 on 360 width screen
//   small: Math.floor(Math.min(width,height) / 25), //14 on 360 width screen
//   xsmall: Math.floor(Math.min(width,height) / 27), //13 on 360 width screen
//   hint: Math.floor(Math.min(width,height) / 30), //12 on 360 width screen
//   tiny: Math.floor(Math.min(width,height) / 36), //10 on 360 width screen
//   xtiny: Math.floor(Math.min(width,height) / 45) //8 on 360 width screen
// }
export const size = {
  h1: 36-2,
  h2: 33-2,
  h3: 30-2,
  input: 18-2,
  xxxlarge: 30-2,
  xxlarge: 25-2,
  xlarge: 20-2,
  large: 17-2,
  regular: 16-2,
  medium: 16-2,
  small: 14-2,
  xsmall: 13-2,
  hint: 12-2,
  tiny: 10-2,
  xtiny: 8-2,
}

export const Fonts = {
  h1: {
    fontSize: size.h1,
  },
  h2: {
    fontSize: size.h2,
  },
  h3: {
    fontSize: size.h3,
  },
  input: {
    fontSize: size.input,
  },
  xxxlarge: {
    fontSize: size.xxxlarge,
  },
  xxlarge: {
    fontSize: size.xxlarge,
  },
  xlarge: {
    fontSize: size.xlarge,
  },
  large: {
    fontSize: size.large,
  },
  normal: {
    fontSize: size.regular,
  },
  medium: {
    fontSize: size.medium,
  },
  small: {
    fontSize: size.small,
  },
  xsmall: {
    fontSize: size.xsmall,
  },
  hint: {
    fontSize: size.hint,
  },
  tiny: {
    fontSize: size.tiny,
  },
  xtiny: {
    fontSize: size.xtiny,
  },
}
export const otaStates = {
    STARTED:"OTA_STATE_STARTED",
    CREATE_AWS_URL:"OTA_STATE_CREATE_AWS_URL",
    CONNECT_AWS:"OTA_STATE_CONNECT_AWS",
    GET_CONTENT_LEN:"OTA_STATE_GET_CONTENT_LEN",
    DOWNLOADING:"OTA_STATE_DOWNLOADING",
    DOWNLOAD_COMPLETE:"OTA_STATE_DOWNLOAD_COMPLETE",
    GET_PARTITION:"OTA_STATE_GET_PARTITION",
    ERASING_PARTITION:"OTA_STATE_ERASING_PARTITION",
    WRITE_APP_IMAGE:"OTA_STATE_WRITE_APP_IMAGE",
    VERIFY_PARTITION:"OTA_STATE_VERIFY_PARTITION",
    SET_PARTITION:"OTA_STATE_SET_PARTITION",
    RESTARTING:"OTA_STATE_RESTARTING",
    ERROR:"OTA_STATE_ERROR",
    CONN_ERROR:"OTA_STATE_CONN_ERROR",   
}

export const actionSheetStyle = {
    overlay: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      opacity: 0.4,
      backgroundColor: Colors.black
    },
    wrapper: {
      flex: 1,
      flexDirection: 'row',
    },
    body: {
      flex: 1,
      alignSelf: 'flex-end',
      backgroundColor: Colors.white,
      borderTopLeftRadius: 40,
      borderTopRightRadius: 40,
      paddingBottom:Spacing.md
    },
    titleBox: {
      height: Spacing.compWidth,
      paddingLeft: Spacing.xl,
      paddingRight: Spacing.xl,
      alignItems: 'flex-start',
      justifyContent: 'center',
      borderTopLeftRadius: 40,
      borderTopRightRadius: 40,
      backgroundColor: Colors.white,
      borderBottomWidth:1,
      borderColor: Colors.light,
    },
    titleText: {
      color: Colors.darkGrey,
      fontSize: 17,
      fontFamily: 'TitilliumWeb-Regular'
    },
    buttonBox: {
      height: Spacing.xxxl,
      paddingLeft: Spacing.xl,
      paddingRight: Spacing.xl,
      alignItems: 'flex-start',
      justifyContent: 'center',
      backgroundColor: Colors.white
    },
    buttonText: {
        color: Colors.darkGrey,
        fontSize: 17,
        fontFamily: 'TitilliumWeb-Regular'
    },
  }

export const graphDataLimit = 200
export const toolSyncTime = 5000 //5s in ms
export const offlineTime = 300 //5 mins in seconds
const aDay = 86400000
export const monthLengths = {
    1: aDay*31,//Jan
    2: aDay*28,//Feb
    3: aDay*31,//Mar
    4: aDay*30,//Apr
    5: aDay*31,//May
    6: aDay*30,//Jun
    7: aDay*31,//Jul
    8: aDay*31,//Aug
    9: aDay*30,//Sep
    10: aDay*31,//Oct
    11: aDay*30,//Nov
    12: aDay*31,//Dec
}
export const calibrationThreshold = 0.05

export const KissBindErr = {
    INVALID_HASH: { code: 147, msg: "Invalid Kiss Bind Hash" },          //!<  Invalid hash was provided
    HASH_MISSING: { code: 148, msg: "No Kiss Bind Hash" },          //!< No Hash value was provided
    NOT_READY: { code: 149, msg: "Token Not Ready" },             //!< Kiss bind token is not ready
    BTN_TIMEOUT: { code: 150, msg: "Button Timeout" },           //!< Kiss bind button timeout
    POST_FAILED: { code: 151, msg: "Failed to send kiss bind token" },           //!< Tool failed to post kiss bind to cloud
    TIME_OUT: { code: 152, msg: "Kiss Bind Timeout" },              //!< Kiss bind retrieval timeout
    NOT_STARTED: { code: 153, msg: "Kiss Bind Not Started" },           //!< Kiss bind was not started
    NO_STABLE_CONNECTION: { code: 154, msg: "Kiss Bind No Stable Connection" },  //!< Tool does not have stable connection
    ALREADY_STARTED: { code: 155, msg: "Kiss Bind Already Started" },       //!< Kiss bind process already started
}

export const WifiErr = {
    SSID_MISSING: {code:108, msg:"No SSID"},
    SSID_INVALID:{code:109, msg:"Invalid SSID"},
    PASS_MISSING:{code:110, msg:"No Password"},
    PASS_INVALID:{code:111, msg:"Invalid Password"},
    CRED_FAILED:{code:112, msg:"Failed to set Credentials"},
}

export const NfcErr = {
    NFC_NOT_ENABLED: { code: 150, msg: "NFC NOT ENABLED" },
    JSON_PARSE: { code: 156, msg: "Couldn't parse response"}//TODO TEMPORARY CODE
}

export const WifiConnectErr ={
    WIFI_REASON_UNSPECIFIED:	1,
    WIFI_REASON_AUTH_EXPIRE:	2,
    WIFI_REASON_AUTH_LEAVE:	3,
    WIFI_REASON_ASSOC_EXPIRE:	4,
    WIFI_REASON_ASSOC_TOOMANY:	5,
    WIFI_REASON_NOT_AUTHED:	6,
    WIFI_REASON_NOT_ASSOCED:	7,
    WIFI_REASON_ASSOC_LEAVE:	8,
    WIFI_REASON_ASSOC_NOT_AUTHED:	9,
    WIFI_REASON_DISASSOC_PWRCAP_BAD:	10,
    WIFI_REASON_DISASSOC_SUPCHAN_BAD:	11,
    WIFI_REASON_IE_INVALID:	13,
    WIFI_REASON_MIC_FAILURE:	14,
    WIFI_REASON_4WAY_HANDSHAKE_TIMEOUT:	15,
    WIFI_REASON_GROUP_KEY_UPDATE_TIMEOUT:	16,
    WIFI_REASON_IE_IN_4WAY_DIFFERS:	17,
    WIFI_REASON_GROUP_CIPHER_INVALID: 	18,
    WIFI_REASON_PAIRWISE_CIPHER_INVALID:	19,
    WIFI_REASON_AKMP_INVALID:	20,
    WIFI_REASON_UNSUPP_RSN_IE_VERSION:	21,
    WIFI_REASON_INVALID_RSN_IE_CAP:	22,
    WIFI_REASON_802_1X_AUTH_FAILED:	23,
    WIFI_REASON_CIPHER_SUITE_REJECTED:	24,
    WIFI_REASON_INVALID_PMKID:	53,
    WIFI_REASON_BEACON_TIMEOUT:	200,
    WIFI_REASON_NO_AP_FOUND:	201,
    WIFI_REASON_AUTH_FAIL:	202,
    WIFI_REASON_ASSOC_FAIL:	203,
    WIFI_REASON_HANDSHAKE_TIMEOUT:	204,
    WIFI_REASON_CONNECTION_FAIL:	205,
    WIFI_REASON_AP_TSF_RESET:	206,
    WIFI_REASON_ROAMING:	207,
}


/**
 * @summary Contains All hash keys
 */
export const HashKeys = {
    KISS_BIND: "7AF7789B4DAF1A41",
    WIFI_PROVISION: "E7A8CA2652326647",
    WIFI_AP: "F4E040C9010FE50F",
    SYSTEM_FACT_RST: "1D8456A788299E7A",
    SYSTEM_RST: "03265D2FB22C1222",
    WIFI_LIST_START: "3F56B643F622C6CD",
    WEB_CHECK_START: "FFDD7B0B045F9BB5",
    WIFI_PROVISION_HEX: [0x45, 0x37, 0x41, 0x38, 0x43, 0x41, 0x32, 0x36, 0x35, 0x32, 0x33, 0x32, 0x36, 0x36, 0x34, 0x37],
    WIFI_AP_HEX: [0x46, 0x34, 0x45, 0x30, 0x34, 0x30, 0x43, 0x39, 0x30, 0x31, 0x30, 0x46, 0x45, 0x35, 0x30, 0x46],
    KISS_BIND_HEX: [0x37, 0x41, 0x46, 0x37, 0x37, 0x38, 0x39, 0x42, 0x34, 0x44, 0x41, 0x46, 0x31, 0x41, 0x34, 0x31],
    SYSTEM_FACT_RST_HEX: [0x31, 0x44, 0x38, 0x34, 0x35, 0x36, 0x41, 0x37, 0x38, 0x38, 0x32, 0x39, 0x39, 0x45, 0x37, 0x41],
    WIFI_LIST_START_HEX: [0x33, 0x46, 0x35, 0x36, 0x42, 0x36, 0x34, 0x33, 0x46, 0x36, 0x32, 0x32, 0x43, 0x36, 0x43, 0x44],
    WEB_CHECK_START_HEX: [0x46, 0x46, 0x44, 0x44, 0x37, 0x42, 0x30, 0x42, 0x30, 0x34, 0x35, 0x46, 0x39, 0x42, 0x42, 0x35],
}

/**
 * @summary Contains tool HTTP calls
 */
export const ToolUri = {
    START_KISS_BIND: (ip) => `http://${ip}/kiss_bind`,          //!< Start the kiss bind process
    GET_KISS_BIND_TOKEN: (ip) => `http://${ip}/kiss_bind/token`, //!< Get the token generated by kiss bind
}

/**
 * @summary Different states for addTool.state
 */
export const AddToolStatus = {
    SUCCESS: 0,           //!< AddTool was successfully  
    FAILED: 1,            //!< AddTool Failed
    IN_PROGRESS: 2,       //!< AddTool in progress
}

/**
 * @summary AWS uri related items
 */
export const Aws = {
    URI: {
        USER_BASE: 'https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/user',
        TOOL_BASE: 'https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/tools',
        SESSION_BASE: 'https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/session',
        STORAGE_BASE: 'https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/storage',
        GRAPH_BASE: "https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/graph",
        MESSAGE_BASE: "https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/messages",
        TEAM_BASE: "https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams",
        GUIDE_BASE:"https://stratus.gitbook.io/stratus"
    },
    
    API_KEY: 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
    GET_TOOLS_OPERATION: "?&operation=get_tools&attributes=",
    GET_MAC_OPERATION: (mac) => `?&operation=get_mac&mac=${mac}&attributes=`,
    GET_SESSIONS_OPERATION: "?&operation=get_user_sessions&attributes=",
    GET_SESSION_ID_OPERATION: (sessionID) => `?&operation=get_session_id&sessionID=${sessionID}`,
    GET_SESSION_FILE_OPERATION: (sessionID, file) => `?sessionID=${sessionID}&file=${file}`,
    GET_LIVE_DATA_OPERATION: (dataID, attributes, lts, uts) => `?&operation=get_curData&data_id=${dataID}&lts=${lts}&uts=${uts}&attributes=${attributes}`,
    GET_LIVE_DATA_OPERATION_10: (dataID, attributes, lts, uts) => `?&operation=get_curData_1r&data_id=${dataID}&lts=${lts}&uts=${uts}&attributes=${attributes}`,
    GET_LIVE_DATA_OPERATION_100: (dataID, attributes, lts, uts) => `?&operation=get_curData_2r&data_id=${dataID}&lts=${lts}&uts=${uts}&attributes=${attributes}`,
    GET_LIVE_DATA_OPERATION_1000: (dataID, attributes, lts, uts) => `?&operation=get_curData_3r&data_id=${dataID}&lts=${lts}&uts=${uts}&attributes=${attributes}`,
    GET_LIVE_DATA_OPERATION_HOUR: (dataID, attributes, lts, uts) => `?&operation=get_curData_hour&data_id=${dataID}&lts=${lts}&uts=${uts}&attributes=${attributes}`,
    GET_LIVE_DATA_OPERATION_DAY: (dataID, attributes, lts, uts) => `?&operation=get_curData_day&data_id=${dataID}&lts=${lts}&uts=${uts}&attributes=${attributes}`,
    GET_LIVE_DATA_OPERATION_MONTH: (dataID, attributes, lts, uts) => `?&operation=get_curData_month&data_id=${dataID}&lts=${lts}&uts=${uts}&attributes=${attributes}`,
    GET_MESSAGES: (attributes) => `?&operation=get_user_messages&attributes=${attributes}`,
    GET_MESSAGE_ID: (messageID,attributes) => `?&operation=get_message_id&message_id=${messageID}&attributes=${attributes}`,
    GET_MESSAGES_TS: (attributes, lts, uts) => `?&operation=get_messages_ts&lts=${lts}&uts=${uts}&attributes=${attributes}`,
    GET_USER:(attributes) => `?&operation=get_user&attributes=${attributes}`,
    GET_SENDER_SHARES: "?&operation=get_sender_shares",
    GET_RECIPIENT_SHARES: "?&operation=get_recipient_shares",
    GET_SHARED_DATA: (shareID, attributes, lts, uts) =>`?&operation=get_shared_devData&share_id=${shareID}&lts=${lts}&uts=${uts}&attributes=${attributes}`,
    GET_SHARED_DATA_10: (shareID, attributes, lts, uts) => `?&operation=get_shared_devData_1r&share_id=${shareID}&lts=${lts}&uts=${uts}&attributes=${attributes}`,
    GET_SHARED_DATA_100: (shareID, attributes, lts, uts) => `?&operation=get_shared_devData_2r&share_id=${shareID}&lts=${lts}&uts=${uts}&attributes=${attributes}`,
    GET_SHARED_DATA_1000: (shareID, attributes, lts, uts) => `?&operation=get_shared_devData_3r&share_id=${shareID}&lts=${lts}&uts=${uts}&attributes=${attributes}`,
    GET_SHARED_TOOL: (shareID) => `?&operation=get_shared_tool&share_id=${shareID}`,
    GET_SHARED_TOOLS: "?&operation=get_user_shared_tools",
    
    OPERATION: {
        UPDATE_TOOL: "update_tool",
        DELETE_TOOL: "delete_tool",
        DELETE_USER_TOOLS: "delete_user_tools",
        MONITOR_USER_TOOLS: "monitor_user_tools",
        MONITOR_TOOL: "monitor_tool",
        ADD_TOOL: "add_tool",
        REASSIGN_TOOL: "reassign_tool",
        LOAD_DEPLOYMENT: "load_deployment",
        SAVE_SESSION: "save_session",
        END_DEPLOYMENT: "end_deployment",
        DELETE_SESSION: "delete_session",
        DELETE_SESSIONS: "delete_multi_sessions",
        DELETE_USER_SESSIONS: "delete_user_sessions",
        UPDATE_SESSION: "update_session",
        FW_STATUS: "tool_fw_status",
        FW_UPDATE: "update_tool_firmware",
        ADD_DEVICE_TOKEN: "add_deviceToken",
        DELETE_DEVICE_TOKEN: "delete_deviceToken",
        DELETE_MESSAGE: "delete_message",
        DELETE_MESSAGES: "delete_multi_messages",
        DELETE_USER_MESSAGES: "delete_user_messages",
        DELETE_MESSAGES_TS: "delete_messages_ts",
        DELETE_MESSAGES_ALERTID: "delete_messages_alertid",
        UPDATE_MESSAGE: "update_message",
        MARK_ALL_READ: "markRead_user_messages",
        GET_ALERTS: "get_alerts_mac",
        ADD_ALERT: "add_alert",
        DELETE_ALERTS: "delete_multi_alerts",
        UPDATE_ALERT: "update_alert",
        CLEAR_DATA: "clear_tool",
        UPDATE_USER: "update_user",
        ADD_FOLDER: "add_sessionFolder",
        DELETE_FOLDER: "delete_sessionFolder",
        DELETE_FOLDERS: "delete_multi_sessionFolders",
        CLEAR_FOLDERS: "clear_sessionFolders",
        MOVE_SESSIONS: "move_multi_sessions",
        RENAME_FOLDER: "rename_sessionFolder",
        EXPORT_FILE: "export_file",
        ADD_SHARE: "add_share",
        DELETE_SHARE: "delete_share",
        UPDATE_SENDER_SETTINGS:"update_sender_settings",
        UPDATE_RECIPIENT_SETTINGS: "update_recipient_settings",
        SAVE_SHARED_SESSION: "save_shared_session",
        EXPORT_SHARED_FILE:"export_shared_file",
        CHECK_RECIPIENT_EMAIL: "check_recipient_email",
        MONITOR_SHARED_TOOLS: "monitor_shared_tools",
        MONITOR_SHARED_TOOL: "monitor_shared_tool",
        CLEAR_SHARED_DATA: "clear_shared_tool",
        ADD_SHARED_ALERT: "add_shared_alert",
        DELETE_SHARED_ALERTS: "delete_shared_multi_alerts",
        UPDATE_SHARED_ALERT: "update_shared_alert",
        UPDATE_SHARED_TOOL: "update_shared_tool",
        DELETE_RECIPIENT_SHARE: "delete_recipient_share",
        CLEAR_ALERT: "clear_alertCnt",
        CLEAR_SHARED_ALERT: "clear_shared_alertCnt",
        CLEAR_ALERTS: "clear_mac_alertCnt",
        CLEAR_SHARED_ALERTS: "clear_shareID_alertCnt",
        SEND_SESSIONS: "send_sessions",
        IDENTIFY_TOOL: "identify_tool",
        IDENTIFY_SHARED_TOOL: "identify_shared_tool",
        GET_GOOGLE_DATA: "get_googleSheetData",
        GET_SHARED_GOOGLE_DATA: "get_shared_googleSheetData",
        CHECK_SUBSCRIPTION: "check_subscription",
        GET_USER_DELETE_TOKEN: "get_user_deleteToken",
        DELETE_USER: "delete_user",
    },

    awsOperationCreator: (operation, data = {}, data2 = {}) => {
        let operObj = {}
        Object.assign(operObj, { operation: operation })

        if (data) {
            Object.assign(operObj, data)
        }

        if (data2) {
            Object.assign(operObj, data2)
        }
        return JSON.stringify(operObj)
    },

    token:async ()=>{
      const session = await Auth.currentSession();
      console.log('currentSession:',session)
      console.log('Token:',session.getAccessToken().getJwtToken())
        return (session.idToken.jwtToken)
    }
}

export const ToolTypes = {
    THP: "STHP",
    SFLR: "SFLR",
    SHUT: "SHUT",
    ANALOG_4_CH: "SA4C",
    THERMO_4_CH: "ST4C",
    VOC: "SVOC",
    SWIM: "SSS1",
    CHEM: "SCP1",
    SDP: "SDP1"
}
const liveTimeMax = 10000//10seconds

export const channelColors = ['#5472EA','#35B532','#CF6537','#C51494','#16AAA1','#C8A729','#C52A49','#8C14C5','#B8B8B8','#898989']
export const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
export const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"]
export const timeFormats = ['12H','24H']
export const dateFormats = ["M/D/YY", "D/M/YY", "YY/M/D","Mon,D,Year"]

export const tiny = 5
export const small = tiny * 2 // 10
export const normal = tiny * 3 // 15
export const medium = normal * 2 // 30
export const large = normal * 3 // 45

export const Metrics = {
  tinyBottomMargin: {
    marginBottom: tiny,
  },
  smallBottomMargin: {
    marginBottom: small,
  },
  bottomMargin: {
    marginBottom: normal,
  },
  mediumBottomMargin: {
    marginBottom: medium,
  },
  largeBottomMargin: {
    marginBottom: large,
  },

  tinyTopMargin: {
    marginTop: tiny,
  },
  smallTopMargin: {
    marginTop: small,
  },
  topMargin: {
    marginTop: normal,
  },
  mediumTopMargin: {
    marginTop: medium,
  },
  largeTopMargin: {
    marginTop: large,
  },

  tinyVerticalMargin: {
    marginTop: tiny,
    marginBottom: tiny,
  },
  smallVerticalMargin: {
    marginTop: small,
    marginBottom: small,
  },
  verticalMargin: {
    marginTop: normal,
    marginBottom: normal,
  },
  mediumVerticalMargin: {
    marginTop: medium,
    marginBottom: medium,
  },

  tinyHorizontalMargin: {
    marginLeft:tiny,
    marginRight:tiny
  },
  smallHorizontalMargin: {
    marginLeft:small,
    marginRight:small
  },
  horizontalMargin: {
    marginLeft:normal,
    marginRight:normal
  },
  mediumHorizontalMargin: {
    marginLeft:medium,
    marginRight:medium
  },
  largeHorizontalMargin: {
    marginLeft:large,
    marginRight:large
  },
  tinyHorizontalPadding: {
    paddingLeft: tiny,
    paddingRight: tiny,
  },
  smallHorizontalPadding: {
    paddingLeft: small,
    paddingRight: small,
  },
  horizontalPadding: {
    paddingLeft: normal,
    paddingRight: normal,
  },
  mediumHorizontalPadding: {
    paddingLeft: medium,
    paddingRight: medium,
  },

  tinyVerticalPadding: {
    paddingTop: tiny,
    paddingBottom: tiny,
  },
  smallVerticalPadding: {
    paddingTop: small,
    paddingBottom: small,
  },
  verticalPadding: {
    paddingTop: normal,
    paddingBottom: normal,
  },
  mediumVerticalPadding: {
    paddingTop: medium,
    paddingBottom: medium,
  },

  tinyTopPadding: {
    paddingTop: tiny,
  },
  smallTopPadding: {
    paddingTop: small,
  },
  topPadding: {
    paddingTop: normal,
  },
  mediumTopPadding: {
    paddingTop: medium,
  },
  largeTopPadding: {
    paddingTop: large,
  },
  tinyBottomPadding: {
    paddingBottom: tiny,
  },
  smallBottomPadding: {
    paddingBottom: small,
  },
  bottomPadding: {
    paddingBottom: normal,
  },
  mediumBottomPadding: {
    paddingBottom: medium,
  },
}

export const sensorLive = {
    getTimeUntil: (time) =>{
      const date = new Date(time * 1000)
      const now = new Date()
      return date-now
    },
    getTimeElapsed: (lastTime) =>{
        const date = new Date(lastTime * 1000)
        const now = new Date()
        return now-date
    },
    isLive: (lastTime) => {
        const timeElapsed = sensorLive.getTimeElapsed(lastTime)
        if(timeElapsed<liveTimeMax) return true
        return false
    },
    getTimeElapsedString: (lastTime) => {
        const timeElapsed = sensorLive.getTimeElapsed(lastTime)
        if(timeElapsed<liveTimeMax){
          return "Live"
        }else{
          if(timeElapsed<60000){//Seconds
            return (Math.floor((timeElapsed/1000)).toString() + (Math.floor((timeElapsed/1000))>1?" seconds ago":" second ago"))
          }else if(timeElapsed<3600000){//Minutes
            return (Math.floor((timeElapsed/60000)).toString() + (Math.floor((timeElapsed/60000))>1?" minutes ago":" minute ago"))
          }else if(timeElapsed<86400000){//Hours
            return (Math.floor((timeElapsed/3600000)).toString() + (Math.floor((timeElapsed/3600000))>1?" hours ago":" hour ago"))
          }else{//Days
            return (Math.floor((timeElapsed/86400000)).toString() + (Math.floor((timeElapsed/86400000))>1?" days ago":" day ago"))
          }
        }
    }
} 